<template>
  <div>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
      </v-col>
      <v-spacer />
      <vehicle-dialog v-if="hasPermissionForEdit" />
    </v-row>
    <v-data-table :headers="headers" :items="vehicles" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.plates }}</td>
          <td class="text-left">{{ props.item.model }}</td>
          <td class="text-left">{{ props.item.engine_capacity }}</td>
          <td class="text-left">{{ props.item.typeName }}</td>
          <td class="text-left">
            <span v-if="props.item.is_private">{{ $t("global.yes") }}</span
            ><span v-if="!props.item.is_private">{{ $t("global.no") }}</span>
          </td>
          <td class="text-center">
            <v-tooltip bottom v-if="hasPermissionForEdit">
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="editItem(props.item)" class="mx-0" icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom v-if="hasPermissionForEdit">
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" v-on="on" @click="deleteItem(props.item)" class="mx-0" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import VehicleDialog from "./VehicleDialog.vue";
import vehicleTypes from "../../../staticData/VehicleTypes.js";

export default {
  name: "VehicleList",
  components: { "vehicle-dialog": VehicleDialog },
  data: () => ({
    search: "",

    vehicle: null
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("vehicleList.headers.plates"), value: "plates" },
        { text: this.$t("vehicleList.headers.model"), value: "model" },
        {
          text: this.$t("vehicleList.headers.engineCapacity"),
          value: "engine_capacity"
        },
        { text: this.$t("vehicleList.headers.type"), value: "typeName" },
        { text: this.$t("vehicleList.headers.isPrivate"), value: "is_private" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    vehicleTypes: vehicleTypes,
    vehicles: function() {
      let temp = this.$store.getters["Vehicle/vehicleList"];
      for (let vehicle of temp) {
        vehicle["typeName"] = this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle["type"]).pop().name;
      }
      return this.$store.getters["Vehicle/vehicleList"];
    },
    hasPermissionForEdit() {
      return this.$store.getters.hasPermission("SuperAdmin") || this.$store.getters.hasPermission("companyAdmin");
    }
  },
  methods: {
    deleteItem(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result.then(() => {
        this.$store.dispatch("Vehicle/removeVehicle", item);
      });
    },
    editItem(item) {
      this.$store.dispatch("Vehicle/editVehicle", item);
    }
  },
  created() {
    this.$store.dispatch("Vehicle/loadAllVehicles");
  }
};
</script>

<style scoped></style>
